module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-change-password/master-change-password.component.scss
// module id = ./src/app/master/master-change-password/master-change-password.component.scss
// module chunks = main